import React from 'react'

import PropTypes from 'prop-types'

import { getRecipeIngredients } from 'routes/Menu/context/recipeContext'

import { Ingredients } from './Ingredients'

import css from '../Detail.css'

const DetailIngredients = ({ recipe, loading }) => {
  const { size, ingredients } = getRecipeIngredients(recipe)

  if (size === 0) {
    return null
  }

  return (
    <div className={css.sectionPanel}>
      <Ingredients loading={loading} ingredients={ingredients} />
    </div>
  )
}

DetailIngredients.propTypes = {
  recipe: PropTypes.instanceOf(Object).isRequired,
  loading: PropTypes.bool.isRequired,
}

export { DetailIngredients }
